/**
 * Represents the admission status of an [[OrderTicketLine]].
 */
export var OrderTicketAdmissionStatus;
(function (OrderTicketAdmissionStatus) {
    /**
     * The patron has not been admitted.
     */
    OrderTicketAdmissionStatus["NotAdmitted"] = "NotAdmitted";
    /**
     * The patron has been admitted.
     */
    OrderTicketAdmissionStatus["Admitted"] = "Admitted";
})(OrderTicketAdmissionStatus || (OrderTicketAdmissionStatus = {}));
//# sourceMappingURL=order-ticket-admission-status.js.map